import PropTypes from "prop-types";
import React, { Fragment, useState, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  getDiscountPrice,
  getProductCartQuantity,
} from "../../helpers/product";
import ProductModal from "./ProductModal";
import { useHistory } from "react-router-dom";
import { isProductTobaccoEligible, getPriceRelatedToCustomer, refModal } from "./../../pages/constant/utils";
import { fetchProductBySlug } from "../../redux/actions/productActions";
import { Select, notification } from "antd";
import { UNIT } from "../../pages/constant/Constants";
import { DropdownInput } from "./DropdownInput";

const ProductGridSingleTwo = ({
  product,
  currency,
  addToCart,
  addToWishlist,
  addToCompare,
  cartItem,
  wishlistItem,
  compareItem,
  cartItems,
  sliderClassName,
  spaceBottomClass,
  colorClass,
  titlePriceClass,
  settings,
  userData,
  settingData,
  userDetail,
}) => {
  const {
    price_display_for_unsecure_user,
    price_display_for_secure_user,
    skip_eligibility_check,
    dist_cont_email,
    currency_symbol,
    ecom_title,
  } = settings || {};
  const [modalShow, setModalShow] = useState(false);
  const [quantityCount, setQuantityCount] = useState("1");
  const { addToast } = useToasts();
  const dispatch = useDispatch();
  const history = useHistory();
  let modalRef = useRef(null);
  const licensePath = () => history.push('/profile/my-account')
  const discountedPrice = getDiscountPrice(product.price, product.discount);
  const finalProductPrice = +(
    Number(getPriceRelatedToCustomer(userData, product)) * currency.currencyRate
  ).toFixed(2);
  const finalDiscountedPrice = +(
    discountedPrice * currency.currencyRate
  ).toFixed(2);
  const [selectedProductColor] = useState(
    product.variation ? product.variation[0].color : ""
  );
  const [selectedProductSize] = useState(
    product.variation ? product.variation[0].size[0].name : ""
  );
  const productCartQty = getProductCartQuantity(
    cartItems,
    product,
    selectedProductColor,
    selectedProductSize
  );
  return (
    <Fragment>
      <div
        className={`col-xl-3 col-md-6 col-lg-4 col-sm-6 ${sliderClassName || ""
          }`}
        style={{ width: "476.25px" }}
      >
        <div
          className={`product-wrap-2 ${spaceBottomClass || ""} ${colorClass || ""
            } `}
        >
          <div className="card">
            <div>
              <div className="rectangle">
                {/* <Group1000005623 className="group" /> */}
                <Link
                  onClick={() => {
                    dispatch(
                      fetchProductBySlug(
                        product,
                        () => {
                          history.push(`/product/${product.slug}`);
                        },
                        () => {
                          history.push(`/shop`);
                        }
                      )
                    );
                  }}
                >
                  <img
                    className="card-image"
                    src={process.env.PUBLIC_URL + product?.images[0]}
                    alt="card-img"
                  />
                </Link>
              </div>
              {product.images.length > 1 && (
                <div
                  // onClick={() => {
                  //   dispatch(
                  //     fetchProductBySlug(
                  //       product,
                  //       () => {
                  //         history.push(`/product/${product.slug}`);
                  //       },
                  //       () => {
                  //         history.push(`/shop`);
                  //       }
                  //     )
                  //   );
                  // }}
                  className="rectangle"
                >
                  <Link
                    onClick={() => {
                      dispatch(
                        fetchProductBySlug(
                          product,
                          () => {
                            history.push(`/product/${product.slug}`);
                          },
                          () => {
                            history.push(`/shop`);
                          }
                        )
                      );
                    }}
                  >
                    <img
                      className="card-image"
                      src={process.env.PUBLIC_URL + product.images[1]}
                      alt=""
                    />
                  </Link>
                </div>
              )}
              {/* <Component className="component-24" divClassName="component-instance" property1="frame-1686556945" /> */}
              <div className="frame-2">
                <div className="frame-3">
                  <div className="frame-4">
                    <div className="text-wrapper-3">smoke</div>
                  </div>
                  <div className="frame-5">
                    <div className="text-wrapper-4">
                      Qty : {product?.saleable_qty}{" "}
                    </div>
                  </div>
                </div>
                <p className="product-name">{product?.ecom_name || product?.name}</p>
                <div className="frame-6">
                  <div className="text-wrapper-5">
                    {currency.currency_symbol}
                    {product.selected_unit_price.price}
                  </div>
                  {/* <div className="text-wrapper-6">$49.99</div> */}
                </div>
              </div>
              <div className="frame-7">
                <div className="frame-8">
                  {/*<div className="text-wrapper-7">Unit</div>
                     <div className="component-2">
                      <div className="text-wrapper-8">Piece</div>
                    </div> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "4px",
                    }}
                  >
                    <label className="lable-unit">Unit</label>
                    <Select
                      disabled
                      value={product.selected_unit_price.unit}
                      className="unit-select"
                    >
                      {Object.keys(UNIT).map((unit) => (
                        <Select.Option value={UNIT[unit].value}>
                          {UNIT[unit].name}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className="frame-9">
                  <div className="frame-10">
                    <div className="text-wrapper-7">
                      <label className="quantity">Quantity</label>
                      <DropdownInput
                        decrement={() =>
                          setQuantityCount(
                            Number(quantityCount) > 1
                              ? Number(quantityCount) - 1
                              : 1
                          )
                        }
                        increment={() => {
                          if (
                            isProductTobaccoEligible(product, userData, settingData)
                          ) {
                            setQuantityCount(
                              Number(quantityCount) < product.saleable_qty
                                ? Number(quantityCount) + 1
                                : Number(quantityCount)
                            );
                          } else {
                            refModal(modalRef, licensePath)
                          }
                        }}
                        value={quantityCount}
                        handleChange={({ target: { value } }) => {
                          const formattedValue = value.replace(/\D/g, "");
                          if (
                            !product.back_order_ecom &&
                            Number(formattedValue) > product.saleable_qty
                          ) {
                            notification.error({
                              message:
                                "You can not add more than in stock quantity",
                            });
                            return;
                          }
                          setQuantityCount(formattedValue);
                        }}
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="add-to-cart "
                    disabled={(() => {
                      if (product.back_order_ecom) {
                        return false;
                      } else if (
                        ["", 0, null].includes(quantityCount) ||
                        productCartQty + Number(quantityCount) >
                        product.saleable_qty
                      ) {
                        return true;
                      }
                    })()}
                    onClick={() => {
                      if (!userDetail?.user) {
                        addToast("Please login first to add in the cart", {
                          appearance: "info",
                          autoDismissTimeout: 1000,
                          autoDismiss: true,
                        });
                      } else {
                        if (
                          isProductTobaccoEligible(product, userData, settingData)
                        ) {
                          addToCart(
                            product,
                            addToast,
                            cartItems,
                            Number(quantityCount),
                            settingData.channel_id,
                          );

                        } else {
                          refModal(modalRef, licensePath)
                        }
                      }
                    }}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProductModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        product={product}
        currency={currency}
        discountedprice={discountedPrice}
        finalproductprice={finalProductPrice}
        finaldiscountedprice={finalDiscountedPrice}
        cartitem={cartItem}
        wishlistitem={wishlistItem}
        compareitem={compareItem}
        addtocart={addToCart}
        addtowishlist={addToWishlist}
        addtocompare={addToCompare}
        addtoast={addToast}
      />
    </Fragment>
  );
};

ProductGridSingleTwo.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItem: PropTypes.object,
  cartItems: PropTypes.array,
  compareItem: PropTypes.object,
  currency: PropTypes.object,
  product: PropTypes.object,
  userData: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  titlePriceClass: PropTypes.string,
  wishlistItem: PropTypes.object,
  settings: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  return {
    settings: state.settingData.ecom.basic,
    userData: state.userData.user,
    cartItems: state.cartData,
    currency: state.settingData?.["admin-panel"]?.basic || {},
  };
};

export default connect(mapStateToProps)(ProductGridSingleTwo);
